// Webpack Imports
import AOS from "aos";
import * as bootstrap from "bootstrap";
import enerclub from "./enerclub";

(function ($) {
  "use strict";

  // Inicializaciones
  AOS.init();

  // - Inicializar componentes formulario
  enerclub.initForm();

  // Cookies
  enerclub.createCookies();

  // Change individual cookie selection
  enerclub.updateCookieSelection();

  enerclub.startShowingCookiesModal();

  $("#CookiePreferenceDialogBodyButtonDecline").on("click", function () {
    enerclub.closeCookiesModal();
  });

  $(".cookies_configuration").on("click", function () {
    enerclub.showCookiesModal();
  });

  $("#cookie_preferences").on("save.bs.cookiePreferences", function () {
    enerclub.createCookies();
    enerclub.startShowingCookiesModal();
  });

  // var $myMenu = $('#menu-main-menu');
  // $myMenu.on('show.bs.collapse', '.collapse', function () {
  //   $myMenu.find('.collapse.in').collapse('hide');
  // });

  // Add -webkit-box-orient prop to container
  // which has limit_lines class
  enerclub.addLimitLinesProp();

  // - Efectos de las imagenes de las cards
  enerclub.cardImgEffects();

  // Show contact form
  enerclub.showContactForm();

  // Focus input if Searchform is empty
  [].forEach.call(document.querySelectorAll(".search-form"), (el) => {
    el.addEventListener("submit", function (e) {
      var search = el.querySelector("input");
      if (search.value.length < 1) {
        e.preventDefault();
        search.focus();
      }
    });
  });

  $('a[href^="#"]').click(function () {
    var destino = $(this.hash);
    if (destino.length == 0) {
      destino = $('a[name="' + this.hash.substr(1) + '"]');
    }
    if (destino.length == 0) {
      destino = $('html');
    }
    $('html, body').animate({ scrollTop: destino.offset().top - 200 }, 300);
    return false;
  });

  // Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
  var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
  var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
    return new bootstrap.Popover(popoverTriggerEl, {
      trigger: "focus",
    });
  });
})(jQuery);

global.enerclub = enerclub;
